module.exports = __webpack_public_path__ + "static/media/east berlin.85ced617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/east berlin.jpg
// module id = 407
// module chunks = 0